var e="@hpstellar/core/reviews";export{e as reviewsTestId};
